export const getOmraadeNameKey = (omraadeId: number | undefined) => {
    return 'navn_omraade_' + omraadeId
}
